module Meevo.Components.Common {

/****************************************************************************************
*	Contract that holds ""key parts"" which are basically repeated portions of keys to	*
*	represent the type of permission or area (tab, field, etc.)							*
*****************************************************************************************/
    export class SecurityParts {
        /**
        * Portion of key used for checking READ permission
        */
        static KEY_PART_READ: string = ":READ";

        /**
        * Portion of key used for checking WRITE permission
        */
        static KEY_PART_WRITE: string = ":WRITE";

        /**
        * Portion of key used for checking ADD permission
        */
        static KEY_PART_CREATE: string = ":CREATE";

        /**
        * Portion of key used for checking WRITE permission
        */
        static KEY_PART_COPY: string = ":COPY";

        /**
        * Portion of key used for checking EXCLUDE/UNEXCLUDE permission
        */
        static KEY_PART_CHANGEACCESS: string =":CHANGEACCESS";

        /**
        * Portion of key used for checking CHANGING OWNERSHIP permission
        */
        static KEY_PART_CHANGEOWNER: string =":CHANGEOWNER";

        /**
        * Portion of key used for checking AVAILABLE TO LOCATIONS permission
        */
        static KEY_PART_AVAILABLETOLOCATIONS: string =":AVAILABLETOLOCATIONS";

        /**
        * Portion of key used for checking DELETE permission
        */
        static KEY_PART_DELETE: string =":DELETE";

        /**
        * Portion of key used for checking UNDELETE permission
        */
        static KEY_PART_UNDELETE: string =":UNDELETE";

        /**
        * Portion of key used to indicate a TAB
        */
        static KEY_PART_TAB: string =":TAB";

        /**
        * Portion of key used to indicate a FIELD
        */
        static KEY_PART_FIELD: string =":FIELD";

        /**
        * Portion of key used to indicate a FIELD GROUP
        */
        static KEY_PART_FIELDGROUP: string =":FIELDGROUP";

        /**
        * Portion of key used to indicate an ACTION
        */
        static KEY_PART_ACTION: string =":ACTION";

        /**
        * Portion of key used to indicate an FILTER
        */
        static KEY_PART_FILTER: string = ":FILTER";

        /**
        * Portion of key used to indicate an FILTER
        */
        static KEY_PART_COMMIT: string = ":COMMIT";

        /**
        * Portion of key used for checking EDIT permission
        */
        static KEY_PART_EDIT: string = ":EDIT";

        /**
        * Portion of key used for checking PURGE permission
        */
        static KEY_PART_PURGE: string = ":PURGE";

    }
}
